import React from 'react';
import {
    AccountCircleRounded,
    PostAdd,
    Subscriptions,
    AccessTime,
    CommentOutlined,
    PersonAdd,
    EmojiEmotions,
    CameraFront,
    OndemandVideo,
    Notifications,
    ShareOutlined,
    ChildFriendly,
    CancelOutlined,
    VpnKey,
    ChangeHistory,
    GroupAdd,
    PostAddOutlined,
    Group,
    ThumbUp,
    ExitToApp,
    SettingsApplications,
} from '@material-ui/icons';
import IntlMessages from '../../../utils/IntlMessages';

export const sidebarNavs = [
    {
        name: <IntlMessages id={'sidebar.general'} />,
        type: 'section',
        children: [
            {
                name: 'Quản lý tài khoản facebook',
                type: 'item',
                icon: <AccountCircleRounded />,
                link: '/general/manage-account-facebook',
            },
            {
                name: 'Quản lý kịch bản',
                type: 'item',
                icon: <Subscriptions />,
                link: '/general/manage-script',
            },
            {
                name: 'Quản lý bài viết',
                type: 'item',
                icon: <PostAddOutlined />,
                link: '/general/manage-posts',
            },
            {
                name: 'Quản lý nhóm tài khoản FB',
                type: 'item',
                icon: <Group />,
                link: '/general/manage-groups',
            },
            {
                name: 'Quản lý Group FB joined',
                type: 'item',
                icon: <PostAddOutlined />,
                link: '/general/manage-group-fb-joined',
            },
            {
                name: 'Quản lý câu hỏi nhóm',
                type: 'item',
                icon: <PostAddOutlined />,
                link: '/general/manage-question-group',
            },
            {
                name: 'Quản lý lịch sử thao tác',
                type: 'item',
                icon: <PostAddOutlined />,
                link: '/general/manage-logs',
            },
            {
                name: 'Quản lý proxy',
                type: 'item',
                icon: <PostAddOutlined />,
                link: '/general/manage-proxies',
            }
        ],
    },
    {
        name: <IntlMessages id={'sidebar.interact'} />,
        type: 'section',
        children: [
            {
                name: 'Lướt newfeed',
                type: 'item',
                icon: <AccessTime />,
                link: '/interact/surf-newfeed',
            },
            {
                name: ' Bình luận bài viết',
                type: 'item',
                icon: <CommentOutlined />,
                link: '/interact/comment',
            },
            {
                name: 'Cảm xúc bài viết',
                type: 'item',
                icon: <EmojiEmotions />,
                link: '/interact/reaction',
            },
            {
                name: 'Xem story',
                type: 'item',
                icon: <CameraFront />,
                link: '/interact/story',
            },
            {
                name: 'Xem video',
                type: 'item',
                icon: <OndemandVideo />,
                link: '/interact/video',
            },
            {
                name: 'Xem thông báo',
                type: 'item',
                icon: <Notifications />,
                link: '/interact/notifications',
            },
            {
                name: 'Chia sẻ bài viết',
                type: 'item',
                icon: <ShareOutlined />,
                link: '/interact/share',
            },
            {
                name: 'Đăng bài',
                type: 'item',
                icon: <PostAddOutlined />,
                link: '/interact/posts',
            },
        ],
    },
    {
        name: 'Tác vụ bạn bè',
        type: 'section',
        children: [
            {
                name: 'Thêm bạn bè',
                type: 'item',
                icon: <PersonAdd />,
                link: '/interactFriend/add-friend',
            },
            {
                name: 'Đồng ý kết bạn',
                type: 'item',
                icon: <ChildFriendly />,
                link: '/interactFriend/accept-invitation',
            },
            {
                name: 'Từ chối bạn bè',
                type: 'item',
                icon: <CancelOutlined />,
                link: '/interactFriend/reject-invitation',
            },
            {
                name: 'Huỷ lời mời bạn bè đã gửi',
                type: 'item',
                icon: <CancelOutlined />,
                link: '/interactFriend/remove-my-invite-friend',
            },
        ],
    },
    {
        name: 'Tác vụ tài khoản',
        type: 'section',
        children: [
            {
                name: 'Tạo/đổi 2FA',
                type: 'item',
                icon: <ChangeHistory />,
                link: '/modifyAccount/2fa',
            },
            {
                name: 'Đổi mật khẩu',
                type: 'item',
                icon: <VpnKey />,
                link: '/modifyAccount/password',
            },
        ],
    },
    {
        name: 'Tương tác nhóm',
        type: 'section',
        children: [
            {
                name: 'Tham gia nhóm',
                type: 'item',
                icon: <GroupAdd />,
                link: '/interactGroup/join-group',
            },
            {
                name: 'Đăng bài viết nhóm',
                type: 'item',
                icon: <PostAddOutlined />,
                link: '/interactGroup/post-article-group',
            },
            {
                name: 'Mời tham gia nhóm',
                type: 'item',
                icon: <GroupAdd />,
                link: '/interactGroup/invite-join-group',
            },
            {
                name: 'Rời nhóm',
                type: 'item',
                icon: <ExitToApp />,
                link: '/interactGroup/leave-group',
            },
            {
                name: 'Cảm xúc bài viết nhóm',
                type: 'item',
                icon: <EmojiEmotions />,
                link: '/interactGroup/like-article-group',
            },
            {
                name: ' Bình luận bài viết nhóm',
                type: 'item',
                icon: <CommentOutlined />,
                link: '/interactGroup/comment-article-group',
            },
            {
                name: 'Tham gia nhóm riêng tư',
                type: 'item',
                icon: <GroupAdd />,
                link: '/interactGroup/join-group-private',
            },
        ],
    },
    {
        name: 'Tương tác trang',
        type: 'section',
        children: [
            {
                name: 'Thích trang',
                type: 'item',
                icon: <ThumbUp />,
                link: '/interactPage/like-page',
            },
            {
                name: 'Mời thích trang',
                type: 'item',
                icon: <ThumbUp />,
                link: '/interactPage/invite-like-page',
            },
        ],
    },
    {
        name: 'Tương tác reels',
        type: 'section',
        children: [
            {
                name: 'Xem reels',
                type: 'item',
                icon: <OndemandVideo />,
                link: '/interact-reels/watch',
            },
            {
                name: 'Bình luận reels',
                type: 'item',
                icon: <CommentOutlined />,
                link: '/interact-reels/comment',
            },
            {
                name: 'Cảm xúc reels',
                type: 'item',
                icon: <EmojiEmotions />,
                link: '/interact-reels/reaction',
            },
        ],
    },
    // {
    //     name: 'Tương tác tự động',
    //     type: 'section',
    //     children: [
    //         {
    //             name: 'Cài đặt',
    //             type: 'item',
    //             icon: <SettingsApplications />,
    //             link: '/interactAuto/auto-reaction',
    //         },
    //     ],
    // },
    {
        name: 'Tài liệu',
        type: 'section',
        children: [
            {
                name: 'Hướng dẫn sử dụng',
                type: 'item',
                icon: <SettingsApplications />,
                link: '/document/manual',
            },
            {
                name: 'Danh sách update',
                type: 'item',
                icon: <SettingsApplications />,
                link: '/document/note-version',
            },
        ],
    },
];
// k
export const horizontalDefaultNavs = [
    {
        name: <IntlMessages id={'sidebar.main'} />,
        type: 'collapse',
        children: [
            {
                name: <IntlMessages id={'pages.samplePage'} />,
                type: 'item',
                icon: <PostAdd />,
                link: '/sample-page',
            },
        ],
    },
];

export const minimalHorizontalMenus = [
    {
        name: <IntlMessages id={'sidebar.main'} />,
        type: 'collapse',
        children: [
            {
                name: <IntlMessages id={'pages.samplePage'} />,
                type: 'item',
                icon: <PostAdd />,
                link: '/sample-page',
            },
        ],
    },
];
